import { BuilderComponentGroup } from '../types'

export const BasicLayoutDesignBlocks: BuilderComponentGroup = {
  id: 'basic-layouts',
  title: 'Basic Layouts',
  components: [
    {
      compId: 'basic-50-50',
      title: '50/50',
      icon: 'basic-layouts',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'basic-70-30',
      title: '70/30',
      icon: 'map',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'basic-30-70',
      title: '30/70',
      icon: 'Columns3070',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'basic-75-25',
      title: '75/25',
      icon: 'Columns7525',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'basic-25-75',
      title: '25/75',
      icon: 'Columns2575',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'basic-33-33-33',
      title: '33/33/33',
      icon: 'Columns333333',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'basic-25-25-25-25',
      title: '25/25/25/25',
      icon: 'Columns25252525',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
  ],
}
